// @flow
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
// eslint-disable-next-line no-duplicate-imports
import type { Router } from 'react-router';

import Guide from '../../components/Guide';
import { setGuide } from '../../actions/version';
import inBrowser from '../../utils/inBrowser';
import { fetchJSON } from '../../utils/fetch';
import type { Guide as GuideInterface } from '../../reducers/version';

type Props = {
  guide: GuideInterface;
  router: Router;
  params: { slug: string; };
  version: string;
  setGuide: typeof setGuide;
};

@withRouter
@connect(({ version: { guide, string } }) => ({
  guide,
  version: string
}), {
  setGuide
})
export default class GuideContainer extends Component<void, Props, void> {
  componentDidMount() {
    this.fetchGuide();
  }

  componentDidUpdate({
    params: {
      slug: prevSlug
    },
    version: prevVersion
  }: Props) {
    const {
      props: {
        params: {
          slug
        },
        version
      }
    } = this;

    if (slug !== prevSlug || version !== prevVersion) {
      this.fetchGuide();
    }
  }

  componentWillUnmount() {
    this.props.setGuide();
  }

  async fetchGuide() {
    if (inBrowser()) {
      const {
        props: {
          router,
          version,
          params: {
            slug
          }
        }
      } = this;

      try {
        const guide = await fetchJSON(
          `/static/data/${version}/guide/${slug}.json`
        );

        this.props.setGuide(guide);
      } catch (err) {
        if (err.statusCode === 404) {
          router.replace('/not-found');
        }
      }
    }
  }

  render() {
    const { props: { guide = {} } } = this;

    return (
      <div>
        <Guide {...guide} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/GuideContainer/index.jsx